import { useQueryClient } from "react-query";
import { generatePath } from "react-router";

import { simpleRequest } from "core/services/api";
import { emptySchema } from "modules/shared/webservices/schemas/responseSchemas";
import { methodSchema } from "core/schemas/http";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";
import { useMutationWithErrorHandling } from "modules/shared/hooks/useMutationWithErrorHandling";
import useFeedbackStore from "modules/feedback/hooks/useFeedbackStore";
import {
  actionsSchema,
  feedbackSchema,
} from "core/components/ActionFeedback/schemas/actionSchemas";

export const deleteImage = (imageId: number) =>
  simpleRequest(
    generatePath(ENDPOINTS.IMAGE, { id: imageId.toString() }),
    emptySchema,
    methodSchema.enum.delete
  );

export function useDeleteImage() {
  const queryClient = useQueryClient();
  const { setFeedback } = useFeedbackStore();
  return useMutationWithErrorHandling(deleteImage, {
    onSuccess: (_, imageId) => {
      queryClient.invalidateQueries(["imagesUrl", imageId]);
      queryClient.invalidateQueries(["images"]);
      queryClient.invalidateQueries(["image", imageId]);

      setFeedback(feedbackSchema.enum.success, actionsSchema.enum.deleteImage);
    },
  });
}
